import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Contact Section */}
        <div className="footer-contact">
          <h3>Contact Us</h3>
          <p><MdLocationOn /> 12 Alade Street, Shomolu, Lagos, Nigeria</p>
          <p><MdPhone /> +234 802 387 9629</p>
          <p><MdEmail /> <a href="mailto:adcoreconsulting@gmail.com">adcoreconsulting@gmail.com</a></p>
        </div>

        {/* Social Media Section */}
        <div className="footer-social">
          <h3>Follow Us</h3>

         <div className="social-box">
          <a href="https://facebook.com/adcoreconsulting" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
          <a href="https://instagram.com/adcoreconsulting" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://twitter.com/adcoreconsulting" aria-label="Twitter" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
         </div>
        </div>

        {/* Quick Links Section */}
        <div className="footer-links">
          <h3>Quick Links</h3>
          <Link to="/about"><h4>About Us</h4></Link>
          <Link to="/term-condition"><h4>Terms & Conditions</h4></Link>
          <Link to="/contact"><h4>Contact Us</h4></Link>
        </div>

        {/* Mission Statement */}
        <div className="footer-mission">
          <p>
            Thank you for choosing Adcore Consulting, where your ideas take shape and come to life. 
            We're committed to delivering top-quality printing services that bring your vision to reality.
          </p>
        </div>
      </div>

      {/* Bottom Footer Section */}
      <div className="footer-bottom">
        <p><strong>Adcore Consulting</strong> <br /> 2024 © All rights reserved. Facilitated by <a href="https://oguntoyinbo.com.ng" target="_blank" rel="noopener noreferrer" style={{ color: "skyblue" }}><strong>TechBrand</strong></a></p>
      </div>
    </footer>
  );
};

export default Footer;
